import * as React from 'react';
import 'kts-invoice-plate/ElectricPlate/PlateRole/index.css';
export default function PlateRole(props) {
    var buyerData = props.buyerData, _a = props.buyerTitle, buyerTitle = _a === void 0 ? {} : _a, sellerData = props.sellerData, _b = props.sellerTitle, sellerTitle = _b === void 0 ? {} : _b;
    return (React.createElement("div", { className: 'electric_plate_role_box' },
        React.createElement("div", { className: 'electric_plate_role_item' },
            React.createElement("div", { className: 'electric_plate_role_name' }, "\u8D2D\u4E70\u65B9\u4FE1\u606F"),
            React.createElement("div", { className: 'electric_plate_role_title_text_box' },
                React.createElement("div", { className: 'electric_plate_role_title_text' }, buyerTitle.nameTitle || '名称'),
                React.createElement("div", { className: 'electric_plate_role_title_text' }, buyerTitle.taxNumberTitle || '统一社会信用代码/纳税人识别号')),
            React.createElement("div", { className: 'electric_plate_role_title_content_box' },
                React.createElement("div", { className: 'electric_plate_role_title_content' }, buyerData.name),
                React.createElement("div", { className: 'electric_plate_role_title_content' }, buyerData.taxNumber))),
        React.createElement("div", { className: 'electric_plate_role_item' },
            React.createElement("div", { className: 'electric_plate_role_name' }, "\u9500\u552E\u65B9\u4FE1\u606F"),
            React.createElement("div", { className: 'electric_plate_role_title_text_box' },
                React.createElement("div", { className: 'electric_plate_role_title_text' }, sellerTitle.nameTitle || '名称'),
                React.createElement("div", { className: 'electric_plate_role_title_text' }, sellerTitle.taxNumberTitle || '统一社会信用代码/纳税人识别号')),
            React.createElement("div", { className: 'electric_plate_role_title_content_box', style: { borderRight: 'none' } },
                React.createElement("div", { className: 'electric_plate_role_title_content' }, sellerData.name),
                React.createElement("div", { className: 'electric_plate_role_title_content' }, sellerData.taxNumber)))));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-invoice-plate/ElectricPlate/PlateRole/index.js
// module id = 4211
// module chunks = 0